import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { BeadChain } from './BeadChain';
import { getRosaryConfig, BeadSequence } from '../../constants/rosarySequences';

interface VirtualRosaryDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  side?: 'left' | 'right';
  prayerType?: string;
  currentBeadIndex?: number;
  onBeadClick?: (beadIndex: number, bead: BeadSequence) => void;
}

export const VirtualRosaryDrawer: React.FC<VirtualRosaryDrawerProps> = ({
  isOpen,
  onClose,
  side = 'right',
  prayerType = 'rosary',
  currentBeadIndex = 0,
  onBeadClick
}) => {
  const [beadSequence, setBeadSequence] = useState<BeadSequence[]>([]);

  // Get the appropriate bead sequence for the prayer type
  useEffect(() => {
    const config = getRosaryConfig(prayerType);
    setBeadSequence(config.beadSequence);
  }, [prayerType]);
  return (
    <>
      {/* Drawer - compact but balanced */}
      <div
        className={`
          fixed top-0 h-full w-16 z-50
          transform transition-transform duration-300 ease-in-out
          ${side === 'right' ? 'right-0' : 'left-0'}
          ${isOpen
            ? 'translate-x-0'
            : side === 'right'
              ? 'translate-x-full'
              : '-translate-x-full'
          }
        `}
      >
        {/* Close button at top */}
        <div className="absolute top-2 right-0.5 z-10">
          <button
            onClick={onClose}
            className="p-0.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
            aria-label="Close rosary drawer"
          >
            <X className="w-3 h-3 text-gray-600 dark:text-gray-400" />
          </button>
        </div>

        {/* Sweet Spot - Hidden but used for positioning calculations */}
        <div
          id="sweet-spot"
          className="absolute right-0.5 top-1/2 transform -translate-y-1/2 z-10 opacity-0 pointer-events-none"
        >
          <div className="w-12 h-12">
          </div>
        </div>


        {/* Progress indicator - simplified for narrow width */}
        {beadSequence.length > 0 && (
          <div className="absolute top-7 left-0.5 right-0.5 z-10">
            <div className="text-center">
              <span className="text-[10px] text-gray-500 dark:text-gray-400 font-medium">
                {currentBeadIndex + 1}/{beadSequence.length}
              </span>
            </div>
          </div>
        )}

        {/* Interactive Bead Chain - Full height with minimal padding */}
        <div className="h-full pt-12 pb-2 px-0.5">
          {beadSequence.length > 0 && (
            <BeadChain
              beadSequence={beadSequence}
              currentBeadIndex={currentBeadIndex}
              onBeadClick={onBeadClick || (() => {})}
              debugOffset={0}
            />
          )}
        </div>
      </div>
    </>
  );
};